import styled from 'styled-components';
import { media } from '../../common/components/ui/utils';

const Container = styled.header`
  padding: 0 .5rem;
  margin-bottom: 2.5rem;

  ${media.tabletNarrow`
    max-width: 800px;
    margin: 0 auto 3.25rem;
  `}
`;

const Title = styled.h2`
  font-weight: 800;
  color: white;
  font-size: 2.5rem;
  line-height: 0.975em;
  margin-bottom: 2rem;
  letter-spacing: -0.035rem;
  
  ${media.tabletNarrow`
    font-size: 4.5rem;
    line-height: 0.8725em;
  `}
`;

const SubTitle = styled.p`
  font-size: 1rem;
  color: white;
  font-weight: 400;
  line-height: 1em;
  max-width: 80%;
  margin: 0 auto;

  ${media.tabletNarrow`
    font-size: 1.375rem;
  `}
`;

export default {
  Container,
  Title,
  SubTitle
};



// WEBPACK FOOTER //
// ./src/modules/search/ui/SearchHeader.js